import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Section } from './shared';
const faqs = [{
  q: '¿Sirve si soy agente independiente o solo para agencias grandes?',
  a: 'Sí. El Megapack está diseñado especialmente para agentes independientes. Todo el sistema está pensado para que una sola persona pueda implementarlo desde el día uno.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmado el pago recibís el acceso por mail en menos de 5 minutos.'
}, {
  q: '¿Qué lo diferencia de los cursos de seguros genéricos?',
  a: 'No es un curso teórico. Es un sistema listo para usar hoy con scripts, prompts y plantillas adaptadas al mercado asegurador argentino.'
}, {
  q: '¿Necesito saber usar IA para aplicarlo?',
  a: 'No. Todo está explicado paso a paso. Si sabés usar WhatsApp, podés usar este sistema.'
}, {
  q: '¿Funciona para cualquier tipo de seguro?',
  a: 'Sí. Los sistemas y scripts están adaptados para autos, vida, hogar, comercio y más.'
}, {
  q: '¿Tiene garantía real?',
  a: '45 días. Sin preguntas. Sin formularios. Devolución del 100%.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-white py-16 sm:py-20" data-id="element-75" data-mp="1ap0yhillnlj0">
      <h2 className="text-center font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-76" data-mp="1fodmi6o7iyn6">
        Preguntas frecuentes
      </h2>
      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-77" data-mp="11w7ej7v7jxyt">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={i} className="overflow-hidden rounded-xl border border-slate-200 bg-slate-50" data-id="element-78" data-mp="16q1xg92zo8wu" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display font-bold text-navy transition-colors hover:bg-slate-100" data-id="element-79" data-mp="rwyfw1pedv64">
                <span className="text-[15px] sm:text-base" data-id="element-80" data-mp="n082jm4z9doe">{f.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-81" data-mp="2pmdbq048f8q8" />
              </button>
              <AnimatePresence initial={false} data-id="element-82" data-mp="2ku3quyhz4yut">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: 'easeInOut'
            }} data-id="element-83" data-mp="2fxlog5a49cln">
                    <p className="px-5 pb-5 text-[15px] leading-relaxed text-slate-600" data-id="element-84" data-mp="2ynbgwlqepmae">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}